<div class="closeicon pointer-hover" (click)="dialogRef.close()">
    <img src="assets/img/svg/cross-btn.svg" alt="close popup" />
</div>
<div class="error-main">
    <div class="error-details-main">
        <div class="text-center call-img" *ngIf="displayImage">
            <img class="back-arrow" src="assets/icon/thankyouheader.svg" alt="thankyou header">
        </div>
        <div class="error-details-flex">
            <div class="error-disclaimer">
                <h2>{{title}}</h2>
                <p class="center f-14 error-text">{{textData}} </p>
            </div>
        </div>
    </div>
    <div class="div-center">
        <button class="btn btn-primary btnconfirm" (click)="dialogRef.close()">OK</button>
    </div>
</div>